/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  name: "Production",
  production: true,
  version: "0.1.0.0",
  apiUrl: "https://loans.fxinfinity.co.za",
  apiWalletUrl: "https://wallet.fxinfinity.co.za",
  mobileSiteUrl: "https://mobile.fxinfinity.co.za",
  // The prod Log Analytics workspace, for the "View server logs" link (work items 704, 924). Not a
  // secret; access is governed by Azure RBAC. Other environments leave it out, which hides the link.
  logAnalytics: {
    workspaceResourceId:
      "/subscriptions/8d448cf1-6a43-4d94-ab81-dcc3151fbf0d/resourceGroups/rg-a2pay-prod/providers/Microsoft.OperationalInsights/workspaces/log-a2pay-prod",
    tenantId: "e29a1e9a-f30e-4bba-9f38-d7081e6c86f6",
  },
  auth0: {
    domain: "a2payproduction-live.us.auth0.com",
    clientId: "nDjIxvjqJKL3lEZ3j46aSpKcbQtzK7sT",
    audience: "https://loans.fxinfinity.co.za/api",
    walletAudience: "https://wallet.fxinfinity.co.za/api",
  },
};
